export default {
  setApplicationStaticConfig (context, payload) {
    return new Promise((resolve, reject) => {
      context.commit("setApplicationStaticConfig", payload)
      resolve()
    })
  },
  setActiveMicroApp (context, payload) {
    return new Promise((resolve, reject) => {
      context.commit("setActiveMicroApp", payload)
      resolve()
    })
  }
}
